export const changelogButtonStyles = {
  headwayContainer: {
    position: "relative",
    cursor: "pointer",
    padding: "5px 10px",

    "#HW_badge_cont": {
      position: "absolute",
      bottom: "50%",
      right: "20px",
      top: "-32px",
      transform: "translateX(50%) translateY(50%)",
    },
    "#HW_badge": {
      fontFamily: "DM Sans, sans-serif",
      lineHeight: "18px",
    },
  },
  headwayContainerLoaded: {
    display: "inline-flex",
  },
  headwayContainerWrapper: {
    padding: "0 30px",
  },
};
